import { FormControl, MenuItem, Select, Switch, Tooltip } from '@material-ui/core';
import { Pagination, PaginationItem } from '@material-ui/lab';
import {
    DataGrid,
    gridPageCountSelector,
    gridPageSelector,
    GridToolbarContainer,
    GridToolbarExport,
    useGridApiContext,
    useGridSelector,
} from '@mui/x-data-grid';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import NullCheckUtil from '../util/NullCheckUtil';

export function CustomToolbar({ fileName }) {
    return (
        <GridToolbarContainer>
            <GridToolbarExport
                csvOptions={{
                    fileName: fileName,
                    utf8WithBom: true,
                }}
            />
        </GridToolbarContainer>
    );
}

export function CustomPagination() {
    const apiRef = useGridApiContext();
    const page = useGridSelector(apiRef, gridPageSelector);
    const pageCount = useGridSelector(apiRef, gridPageCountSelector);

    return (
        <div className='grid-table-footer'>
            <Pagination
                color='primary'
                shape='rounded'
                page={page + 1}
                count={pageCount}
                // @ts-expect-error
                renderItem={(props2) => <PaginationItem {...props2} disableRipple />}
                onChange={(e, value) => apiRef.current.setPage(value - 1)}
            />
        </div>
    );
}

export function defaultTooltipRender(params, column) {
    var value = params.getValue(params.id, column.field);
    return NullCheckUtil.isNotNull(value) ? (
        <Tooltip title={column.renderCell ? column.renderCell(params) : value}>
            <div className='grid-cell'>{column.renderCell ? column.renderCell(params) : value}</div>
        </Tooltip>
    ) : (
        ''
    );
}

export function EmptyPagination() {
    return <div className='grid-table-footer' />;
}

export const pagePerCountOptions = [10, 20, 50, 100];

const TableBox = ({ isSupportedWide = true, defaultWide = true }) => {
    const {
        control: { columns, onRowDoubleClick, onRowClick, onChangePageInfo, params },
        gridData: { rows, totalCount, page, pageSize },
    } = useSelector((state) => state.tableBoxState);

    const onChangePage = (page) => {
        onChangePageInfo && onChangePageInfo(page, pageSize);
    };

    const onChangePageSize = (e) => {
        onChangePageInfo && onChangePageInfo(page, e.target.value);
    };

    // Wide 모드를 지원하여 기본값을 Wide 모드로 처리함.
    const [wideChecked, setWideChecked] = useState(isSupportedWide ? defaultWide : false);

    const onClickWide = (e) => {
        setWideChecked(e.target.checked);
    };

    return (
        <>
            <div className={'result-table-box ' + (wideChecked ? 'wide' : '')}>
                <div className='grid-table'>
                    <div className='grid-table-head'>
                        <div className='head-text'>총 {totalCount}건</div>

                        <div className='head-select'>
                            {isSupportedWide ? (
                                <>
                                    <div>와이드모드</div>
                                    <Switch
                                        checked={wideChecked}
                                        onChange={(e) => onClickWide(e)}
                                        name='확대/보통'
                                        color='primary'
                                    />
                                </>
                            ) : (
                                <></>
                            )}
                            <div>페이지사이즈</div>
                            <FormControl className='grid-table-head-item' variant='outlined' size='small'>
                                <Select value={pageSize} onChange={onChangePageSize}>
                                    {pagePerCountOptions.map((item, index) => (
                                        <MenuItem key={index} value={item}>
                                            {item}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>
                    </div>
                    <div className='grid-table-body'>
                        {columns.length > 0 ? (
                            <DataGrid
                                autoHeight
                                hideFooterSelectedRowCount
                                pagination
                                page={page}
                                pageSize={pageSize}
                                paginationMode='server'
                                columns={
                                    columns &&
                                    columns.map((column) =>
                                        column.tooltip
                                            ? {
                                                  ...column,
                                                  renderCell: (params) => defaultTooltipRender(params, column),
                                              }
                                            : column,
                                    )
                                }
                                rows={rows}
                                rowCount={totalCount}
                                onPageChange={onChangePage}
                                onRowDoubleClick={(item) => onRowDoubleClick(item.row, params)}
                                onRowClick={onRowClick && onRowClick}
                                components={{
                                    Pagination: CustomPagination,
                                }}
                                sx={{
                                    '.MuiDataGrid-columnSeparator': {
                                        display: 'none',
                                    },
                                    '&.MuiDataGrid-root': {
                                        borderLeft: 'none',
                                        borderRight: 'none',
                                        borderBottom: 'none',
                                        fontFamily: 'inherit',
                                    },
                                }}
                            />
                        ) : (
                            <></>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default TableBox;
